import { render, staticRenderFns } from "./Inscriptions-grupo-cria.vue?vue&type=template&id=5510bc21&scoped=true&"
import script from "./Inscriptions-grupo-cria.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-grupo-cria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510bc21",
  null
  
)

export default component.exports